export default "__VITE_ASSET__NnVCKXlE__"